import React, { useState } from "react";
import {
  addNewList,
  deleteList,
  updateListName,
} from "../../../server/ShoppingList";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { globalFileServer, globalFileIcon } from "../../../../axiosInstance";
import { addToCard, customerListId } from "../../../server/ShoppingList";
import showAlert from "../../../server/ShowAlert";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";
import { getCart } from "../../../server/CollectSite";

const UserShoppingList = ({ name }) => {
  const dispatch = useDispatch();
  const stationId = useSelector((state) => state.user.stationId);
  const shoppingList = useSelector((state) => state.shoppingList.shoppingList);
  const [newItemName, setNewItemName] = useState("");

  const addNewItemToList = () => {
    if (newItemName === "") {
      showAlert({ msgTitle: "הכנס שם לרשימה", msgType: "success" });
      return;
    }
    dispatch(addNewList(newItemName));
    setNewItemName("");
  };

  const handleDeleteList = (listId) => {
    showAlertWithConfirmCancel({
      msgTitle: "האם את/ה בטוח/ה שברצונך למחוק את הרשימה?",
      confirmText: "מחק",
      cancelText: "ביטול",
      onConfirm: () => {
        dispatch(deleteList(listId));
      },
    });
  };
  const AddToCard = async (stationId, list) => {
    if (!stationId) {
      showAlert({ msgTitle: "אין תחנה מוגדרת", msgType: "error" });
      return;
    }

    let products = list.items;

    if (!products || products.length === 0) {
      try {
        const response = await customerListId(list.id, stationId);
        products = response.data.items || [];
      } catch (e) {
        console.error(e);
        showAlert({ msgTitle: "שגיאה בטעינת מוצרים", msgType: "error" });
        return;
      }
    }

    if (products.length === 0) {
      showAlert({ msgTitle: "אין מוצרים ברשימה", msgType: "error" });
      return;
    }

    try {
      const response = await addToCard(stationId, products);
      const reservedItems = response.data?.reservedItems || [];
      handleCartResponse(
        reservedItems,
        products,
        dispatch,
        stationId,
        showAlert,
        getCart,
        response.data?.allFailed,
      );
    } catch (e) {
      console.error(e);
      showAlert({ msgTitle: "שגיאה בהוספה לעגלה", msgType: "error" });
    }
  };

  const [editingListId, setEditingListId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const startEdit = (item) => {
    setEditingListId(item.id);
    setEditedName(item.name);
  };

  const cancelEdit = () => {
    setEditingListId(null);
    setEditedName("");
  };

  const saveEdit = (id) => {
    if (!editedName.trim()) {
      showAlert({ msgTitle: "שם הרשימה לא יכול להיות ריק", msgType: "error" });
      return;
    }

    dispatch(updateListName(id, editedName));
    setEditingListId(null);
  };

  return (
    <div className="shopping-list">
      {shoppingList ? (
        <div>
          <p className="shopping-list-header">
            {" "}
            <img
              loading="lazy"
              src={globalFileIcon + "listHeader.svg"}
              alt="list"
            />
            הרשימות של {name}
          </p>
          <div className="list">
            {shoppingList.map((item) => (
              <div
                className="list-data"
                key={item.id}
                style={{
                  backgroundImage: `url(${globalFileIcon + "itemBg.svg"})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100%",
                  backgroundColor: "transparent",
                  height: "100%",
                }}
              >
                <img
                  loading="lazy"
                  className="delete"
                  onClick={() => handleDeleteList(item.id)}
                  src={globalFileServer + "iconcss/deleteLocationAndListI.svg"}
                  alt="delete"
                />

                {editingListId === item.id ? (
                  <input
                    type="text"
                    value={editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") saveEdit(item.id);
                      if (e.key === "Escape") cancelEdit();
                    }}
                    onBlur={() => saveEdit(item.id)}
                    autoFocus
                  />
                ) : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <NavLink
                      className="list-name"
                      to={`/shopping-list-product/${item.id}`}
                      style={{ marginRight: "8px" }}
                    >
                      {item.name}
                    </NavLink>
                    <button
                      className="btn-edit"
                      onClick={() => startEdit(item)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      <img
                        src={globalFileServer + "iconcss/edit.svg"}
                        alt="edit"
                        width={16}
                        height={16}
                      />
                    </button>
                  </div>
                )}
                <button
                  className="btn-add"
                  onClick={() => AddToCard(stationId, item)}
                >
                  הוסף לסל קניות&gt;
                </button>
              </div>
            ))}

            <div
              className="add-item"
              style={{
                backgroundImage: `url(${globalFileIcon + "addressBg.svg"})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100%",
                backgroundColor: "transparent",
                width: "140px",
                height: "130px",
                margin: "10px",
              }}
            >
              <input
                placeholder="הכנס שם לרשימה חדשה"
                type="text"
                value={newItemName ? newItemName : ""}
                onChange={(e) => setNewItemName(e.target.value)}
                onBlur={(e) => setNewItemName(e.target.value)}
              />
              <button className="btn-add-item" onClick={addNewItemToList}>
                הוסף רשימה
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="empty-list">
          <h1>אין רשימת קניות </h1>
          <div
            className="add-item"
            style={{
              backgroundImage: `url(${globalFileIcon + "addressBg.svg"})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              backgroundColor: "transparent",
              height: "20%",
              width: "150px",
            }}
          >
            <input
              placeholder="הכנס שם לרשימה חדשה"
              type="text"
              value={newItemName ? newItemName : ""}
              onChange={(e) => setNewItemName(e.target.value)}
              onBlur={(e) => setNewItemName(e.target.value)}
            />
            <button className="btn-add-item" onClick={addNewItemToList}>
              הוסף רשימה
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserShoppingList;
export const handleCartResponse = (
  reservedItems,
  products,
  dispatch,
  stationId,
  showAlert,
  getCart,
  allFailed,
) => {
  const errors = [];
  const added = [];

  reservedItems.forEach((item) => {
    const originalProduct = products.find(
      (p) => p.productId === item.productId,
    );
    const productName = originalProduct?.product?.name || item.productId;

    if (item.status === "ERROR") {
      errors.push(productName);
    } else if (item.status === "PARTIAL") {
      errors.push(
        `${productName} (נוסף חלקית - חסר ${item.missingQuantity} יחידות)`,
      );
    } else if (item.status === "RESERVED") {
      if (item.isPriceChanged) {
        showAlert({
          msgTitle: `מוצר ${productName} השתנה ממחיר ${item.priceChangedItem?.oldUnitPrice ?? item.unitPrice}₪ ל־${item.unitPrice}₪`,
          msgType: "warning",
        });
      }
      added.push(productName);
    }
  });
  if (allFailed) {
    showAlert({
      msgTitle: "כל המוצרים לא הצליחו להתווסף לעגלה עקב חוסר במלאי",
      msgType: "error",
    });
  } else if (errors.length > 0) {
    showAlert({
      msgTitle: `כל המוצרים התווספו בהצלחה חוץ מהמוצרים הבאים: ${errors.join(", ")}. מומלץ לבדוק באתר אם קיימים מוצרים דומים.`,
      msgType: "info",
    });
  } else {
    showAlert({
      msgTitle: "הרשימה התווספה לעגלת קניות",
      msgType: "success",
    });
  }

  dispatch(getCart(stationId));
};
